export enum ChannelType
{
	Master = "master",
	Sfx = "sfx",
	Amb = "amb"

}